import { createTheme } from '@mui/material/styles'

const muiTheme = createTheme({
  palette: {
    primary: { main: '#F6B400' },
    secondary: { main: '#6B3E0B' },
    background: {
      default: '#FFF7E8',
      paper: '#FFFDF5',
    },
    text: {
      primary: '#2B1A0F',
      secondary: '#6B4A2B',
    },
  },
  shape: {
    borderRadius: 16,
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 24,
        },
      },
    },
    // Tables: tighter corners, a clear header band and visible row separators
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '&.MuiPaper-root': { borderRadius: 8 },
          border: '1px solid #E6DCC8',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#F3EBDB',
            color: '#2B1A0F',
            fontWeight: 700,
            fontSize: '0.875rem',
            borderBottom: '2px solid #D9C9A8',
            whiteSpace: 'nowrap',
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          '& .MuiTableRow-root:nth-of-type(even)': { backgroundColor: '#FBF6EC' },
          '& .MuiTableRow-root:hover': { backgroundColor: '#F6EEDD' },
          '& .MuiTableRow-root:last-of-type .MuiTableCell-body': { borderBottom: 0 },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #EDE4D3',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 12,
        },
      },
    },
  },
})

export default muiTheme
